<template>
  <Dialog :visible="isModalForSeparateOpen" :modal="true" :closable="false" :style="{ width: '1250px' }">
    <template #header>
      <div class="d-flex align-items-center w-100 border-bottom border-3 pb-3">
        <div class="me-auto">
          <h3 class="mb-0">Helyiségek szétbontása</h3>
        </div>
        <div class="d-flex align-items-center text-center gap-3 me-4">
          <div class="border-start border-end border-3 px-3">
            <h1 class="text-sm text-uppercase">Helyiségszám változás</h1>
            <span class="badge bg-success">{{ newAreas.length - 1 }}</span>
          </div>
          <div class="border-start border-end border-3 px-3">
            <h1 class="text-sm text-uppercase">Feldolgozatlan terület</h1>
            <span
              class="badge bg-danger"
            >
              {{ (totalGrossFloorSpace - originalArea.gross_floor_space) > 0 ? '+' : '' }}
              {{ (totalGrossFloorSpace - originalArea.gross_floor_space) }} m²
            </span>
          </div>
          <div class="d-flex flex-column gap-1">
            <Button label="Mégse"  text class="bg-danger py-1 text-white" @click="hideDialog" />
            <Button label="Mentés" :loading="loading" :disabled="isSaveDisabled" class="py-1" @click="saveArea" />
          </div>
        </div>
      </div>
    </template>
    <div class="row ms-2 mt-4">
      <div class="col-2">
        <label for="identifier" class="block font-bold" style="display: block; font-weight: 700;">Bérlemény azonostó</label>
      </div>
      <div class="col-2">
        <label for="netFloorSpace" class="block font-bold" style="display: block; font-weight: 700;">Helyiség funkció</label>
      </div>
      <div class="col-2">
        <label for="netFloorSpace" class="block font-bold" style="display: block; font-weight: 700;">Helyiség száma</label>
      </div>
      <div class="col-2">
        <label for="grossFloorSpace" class="block font-bold" style="display: block; font-weight: 700;">Nettó terület</label>
      </div>
      <div class="col-2">
        <label for="grossFloorSpace" class="block font-bold" style="display: block; font-weight: 700;">Bruttó terület</label>
      </div>
      <div class="col-2" />
    </div>
    <div v-for="(data, index) in newAreas" :key="index" class="px-4">
      <div class="row py-2">
        <div class="col-2">
          <InputText 
            id="identifier" 
            v-model.trim="originalArea.identifier" 
            required="true"
            placeholder="(Kötelező)" 
            autofocus 
            fluid
            v-show="index === 0"
            disabled
          />
          <InputText 
            id="identifier" 
            v-model.trim="newAreas[index].identifier"
            required="true"
            placeholder="(Kötelező)"  
            autofocus 
            fluid
            v-show="index != 0"
          />
          <small v-if="submitted && !newAreas[index].identifier" class="text-red-500">Azonostó szükséges.</small>
        </div>
        <div class="col-2">
            <FormDropdown 
              v-model="originalArea.utilization_id"
              :disabled="true"
              :possible-values="areaUtilizationList"
              placeholder="Kötelező"
              class="w-full"
              v-show="index === 0"
            />
            <Select 
              v-model="newAreas[index].rental_utilization_id"
              :options="areaRentalUtilizationList"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid
              v-show="index != 0"
            />
          <small v-if="submitted && !newAreas[index].rental_utilization_id" class="text-red-500">Bérlemény hasznosítás szükséges.</small>
        </div>
        <div class="col-2">
            <FormDropdown 
              v-model="originalArea.area_numbers_id"
              :disabled="true"
              :possible-values="areaNumbersList"
              placeholder="Kötelező"
              class="w-full"
              v-show="index === 0"
            />
            <Select 
              id="area_numbers_id" 
              v-model="newAreas[index].area_numbers_id"
              :options="areaNumbersListSelect"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid 
              v-show="index != 0"
            />
          <small v-if="submitted && !newAreas[index].area_numbers_id" class="text-red-500">Bruttó terület szükséges.</small>
        </div>
        <div class="col-2">
          <InputText 
            id="netFloorSpace" 
            v-model.trim="originalArea.net_floor_space" 
            required="true" 
            autofocus  
            placeholder="(Kötelező)" 
            fluid
            v-show="index === 0"
            disabled
          />
          <InputText 
            id="netFloorSpace" 
            v-model.trim="newAreas[index].net_floor_space" 
            required="true" 
            placeholder="(Kötelező)" 
            autofocus 
            fluid
            v-show="index != 0"
          />
          <small v-if="submitted && !newAreas[index].net_floor_space" class="text-red-500">Nettó terület szükséges.</small>
        </div>
        <div class="col-2">
          <InputText 
            id="grossFloorSpace" 
            v-model.trim="originalArea.gross_floor_space" 
            required="true" 
            autofocus 
            placeholder="(Kötelező)" 
            fluid
            v-show="index === 0"
            disabled
          />
          <InputText 
            id="identifier" 
            v-model.trim="newAreas[index].gross_floor_space" 
            required="true" 
            placeholder="(Kötelező)" 
            autofocus 
            fluid
            v-show="index != 0"
          />
          <small v-if="submitted && !newAreas[index].gross_floor_space" class="text-red-500">Bruttó terület szükséges.</small>
        </div>
        <div class="col-2 d-table d-flex justify-content-center align-items-end pb-2">
          <span aria-hidden="true" class="text-xs font-weight-bold d-table-cell align-middle d-flex justify-content-center align-items-center gap-2">
            <i v-show="index != 0" class="fas fa-list cursor-pointer mb-2 me-3 fa-2x"  @click="areaDialogs[index] = true"></i>
            <i v-show="index != 0" class="fas fa-minus-circle text-danger cursor-pointer mb-2 fa-2x" @click="remove(index)"></i>
          </span>
        </div>
      </div>
      <Dialog v-model:visible="areaDialogs[index]" @update:visible="areaDialogs[index] = false" :modal="true" :style="{ width: '450px' }" header="Új helyiség adatai">
        <div class="flex flex-col" style="display: flex;flex-direction: column; gap: 1rem;">
          <div>
            <label for="area_buildings_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Épületszám</label>
            <Select 
              id="area_buildings_id"
              v-model="newAreas[index].area_buildings_id" 
              :options="buildingsList"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid 
            />
          </div>
          <div>
            <label for="area_positions_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Pozíció</label>
            <Select 
              id="area_positions_id"
              v-model="newAreas[index].area_positions_id"
              :options="filteredAreaPositionsList"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid
            />
          </div>
          <div>
            <label for="area_positions_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Funkció</label>
            <Select 
              id="area_functions_id" 
              v-model="newAreas[index].area_functions_id"
              :options="areaFunctionsListSelect"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid
            />
          </div>
          <div>
            <label for="lot_number" class="block font-bold mb-3" style="display: block; font-weight: 700;">Helyrajzi szám</label>
            <InputText 
              id="lot_number" 
              v-model.trim="newAreas[index].lot_number"
              required="true"
              autofocus 
              fluid 
              placeholder="(Kötelező)" 
              disabled
            />
            <small v-if="submitted && !newAreas[index].lot_number" class="text-red-500">Helyrajzi szám szükséges.</small>
          </div>
          <div>
            <label for="height" class="block font-bold mb-3" style="display: block; font-weight: 700;">Magasság</label>
            <InputText 
              id="height" 
              v-model.trim="newAreas[index].height"
              required="true" 
              placeholder="(Opcionális)" 
              autofocus 
              fluid 
            />
            <small v-if="submitted && !newAreas[index].height" class="text-red-500">Magasság szükséges.</small>
          </div>
          <div >
            <label for="area_floor_coverings_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Burkolat</label>
            <Select 
              id="area_floor_coverings_id" 
              v-model="newAreas[index].area_floor_coverings_id"
              :options="areaFloorCoveringsList"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Kötelező)" 
              fluid
            />
          </div>
          <div class="pb-4">
            <label for="wall_structure_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Falszerkezet</label>
            <Select 
              id="wall_structure_id" 
              v-model="newAreas[index].wall_structure_id"
              :options="areaWallStructuresList"
              optionLabel="name" 
              optionValue="id" 
              placeholder="(Opcionális)" 
              fluid
            />
          </div>
        </div>
        <template #footer>
          <Button label="Kész" icon="pi pi-check" @click="areaDialogs[index] = false" />
        </template>
      </Dialog>
    </div>
    <template #footer>
      <i class="btn btn-success d-inline-flex align-items-center gap-1 text-uppercase me-1" @click="addMore()">
        Helyiség +
      </i>
    </template>
  </Dialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from "vue";
import { useStore } from "vuex";
import showSwal from "../../../../mixins/showSwal";
import FormDropdown from "../../../../components/FormDropdown.vue";

const props = defineProps({
  isModalForSeparateOpen: Boolean,
  selectedareas: Object,
  realestateId: String,
});

const emit = defineEmits(["close"]);
const hideDialog = () => {
  emit("close");
};

const submitted = ref(false);
const loading = ref(false);
const areaDialogs = ref([false]);
const originalArea = ref({
    id: null, 
    identifier: "",
    realestate_id: "",
    area_buildings_id: "", 
    utilization_id: "",
    area_numbers_id: "", 
    lot_number: "",
    area_positions_id: "",
    area_functions_id: "", 
    net_floor_space: 0,
    gross_floor_space: 0, 
    height: 0, 
    area_floor_coverings_id: "", 
    wall_structure_id: "", 
});
const newAreas = ref([
  {
    id: null, 
    identifier: "",
    realestate_id: "",
    area_buildings_id: "", 
    rental_utilization_id: "",
    area_numbers_id: "", 
    lot_number: "",
    area_positions_id: "",
    area_functions_id: "", 
    net_floor_space: 0,
    gross_floor_space: 0, 
    height: 0, 
    area_floor_coverings_id: "", 
    wall_structure_id: "", 
  },
]);
const addMore = () => {
  newAreas.value.push({
    id: null, 
    identifier: "",
    realestate_id: "",
    area_buildings_id: "", 
    rental_utilization_id: "",
    area_numbers_id: "", 
    lot_number: originalArea.value.lot_number,
    area_positions_id: "",
    area_functions_id: "", 
    net_floor_space: 0,
    gross_floor_space: 0, 
    height: originalArea.value.height, 
    area_floor_coverings_id: "", 
    wall_structure_id: "", 
  });
  areaDialogs.value.push(false);
};

const remove = (index) => {
  newAreas.value.splice(index, 1);
};

const store = useStore();
const buildingsList = computed(() => store.getters["buildings/getBuildingsData"] || []);
const areaPositionsList = computed(() => store.getters["positions/getPositionsData"] || []);
const areaNumbersListSelect = computed(() => store.getters["areanumbers/getAreanumbersData"] || []);
const areaFunctionsListSelect = computed(() => store.getters["afunctions/getFunctionsData"] || []);
const areaFloorCoveringsList = computed(() => store.getters["coverings/getCoveringsData"] || []);
const areaWallStructuresList = computed(() => store.getters["wallstructures/getWallStructuresData"] || []);
const areaRentalUtilizationList = computed(() => store.getters["rentalutilization/getRentalUtilizationData"] || []);

const areaUtilizationList = computed(() => {
  const list = store.getters["rentalutilization/getRentalUtilizationData"] || [];
  return list.map(item => ({
    value: item.id.toString(),
    label: item.name
  }));
});

const areaNumbersList = computed(() => {
  const list = store.getters["areanumbers/getAreanumbersData"] || [];
  return list.map(item => ({
    value: item.id.toString(),
    label: item.name
  }));
});

const filteredAreaPositionsList = computed(() => {
  return areaPositionsList.value.filter(areaPosition =>
    props.selectedareas.some(area =>
      area.area_position.some(p => p.id == areaPosition.id)
    )
  );
});

const totalNetFloorSpace = computed(() => 
  newAreas.value.reduce((sum, area) => sum + Number(area.net_floor_space), 0)
);
const totalGrossFloorSpace = computed(() => 
  newAreas.value.reduce((sum, area) => sum + Number(area.gross_floor_space), 0)
);

watch(() => props.selectedareas, (newVal) => {
  if (newVal && newVal.length > 0) {
    const selectedArea = newVal[0];
    
    const areaNumbersId = selectedArea.area_numbers && selectedArea.area_numbers.length > 0 
      ? selectedArea.area_numbers[0].id 
      : selectedArea.area_numbers_id || "";
      
   const areaFunctionsId = selectedArea.area_functions && selectedArea.area_functions.length > 0
      ? selectedArea.area_functions[0].id
      : selectedArea.area_functions_id || "";
    
    originalArea.value = {
      id: selectedArea.id || null,
      identifier: selectedArea.identifier || "",
      rental_utilization_id: selectedArea.utilization_id || null,
      net_floor_space: selectedArea.net_floor_space || 0,
      gross_floor_space: selectedArea.gross_floor_space || 0,
      lot_number: selectedArea.lot_number || "",
      area_buildings_id: selectedArea.area_buildings_id || "",
      area_numbers_id: areaNumbersId,
      height: selectedArea.height || "",
      area_floor_coverings_id: selectedArea.area_floor_coverings_id || "",
      area_positions_id: selectedArea.area_positions_id || "",
      area_functions_id: String(areaFunctionsId),
    };
  }
}, { immediate: true });

const isSaveDisabled = computed(() => {
  if (newAreas.value.length <= 1) {
    return true;
  }

  for (let i = 1; i < newAreas.value.length; i++) {
    const area = newAreas.value[i];
    if (
      !area.identifier?.trim() ||
      Number(area.net_floor_space) <= 0 ||
      Number(area.gross_floor_space) <= 0 ||
      !area.area_buildings_id ||
      !area.area_numbers_id ||
      !area.utilization_id ||
      !area.area_positions_id ||
      !area.area_functions_id ||
      !area.lot_number ||
      !area.height ||
      !area.area_floor_coverings_id
    ) {
      return true;
    }
  }

  const originalNet = Number(originalArea.value.net_floor_space);
  const originalGross = Number(originalArea.value.gross_floor_space);
  
  if (totalNetFloorSpace.value > originalNet || totalGrossFloorSpace.value > originalGross) {
    return true;
  }

  return false;
});

const deleteOriginalArea = async () => {
  try {
    const netFloorSpace = Number(originalArea.value.net_floor_space) || 0;
    const grossFloorSpace = Number(originalArea.value.gross_floor_space) || 0;
    
    if (netFloorSpace === 0 && grossFloorSpace === 0) {
      await store.dispatch("areas/deleteArea", originalArea.value.id);
      emit("removeArea", originalArea.value.id);
    }
  } catch (error) {
    console.log('Error in deleting original area:', error);
  }
};

const editArea = () => {
  const totalNet = Number(totalNetFloorSpace.value) || 0;
  const totalGross = Number(totalGrossFloorSpace.value) || 0;

  originalArea.value.net_floor_space = String(Number(originalArea.value.net_floor_space) - totalNet);
  originalArea.value.gross_floor_space = String(Number(originalArea.value.gross_floor_space) - totalGross);

  store.dispatch("areas/editArea", originalArea.value);
};

const saveArea = async () => {
  submitted.value = true;
  loading.value = true;
  try {
    const savedAreas = [];
    for (let i = 1; i < newAreas.value.length; i++) {
      const area = newAreas.value[i];
      if (area.identifier) {
        area.realestate_id = props.realestateId;
        const areaId = await store.dispatch("areas/addArea", area);
        savedAreas.push({...area, id: areaId.toString()});
      }
    }
    editArea();
    await deleteOriginalArea();
    emit("editAreas", savedAreas);
    emit("editNetFloorSpace", originalArea.value);
    loading.value = false;
    showSwal.methods.showSwal({
      type: "success",
      message: "Sikeresen mentette a helyiségeket!",
      width: 500
    });
    emit("close");
    
  } catch (error) {
    console.log('Error in saving the areas:', error);
    showSwal.methods.showSwal({
      type: "error",
      message: "Valami hiba történt!",
      width: 500
    });
    loading.value = false;
  }
};
</script>